import { RegisterItem } from '../decorators/snitem-factory-decorator';
import { CNContactRXImage } from './cncontactrximage';
import { SNItem } from './snitem';

@RegisterItem()
export class CNContactRXSerie extends SNItem {

    public images: CNContactRXImage[];
    public rxImages: CNContactRXImage[];
    public baseurl: string;

    constructor(itemid: number = 0) {
        super(itemid);
        this.key = 'SNItem.CNItem.CNContactRXSerie';
    }

    get name(): string {
        return this.getProperty('Name');
    }
    /**
     * factory clone
     * @returns CNContactRXSerie
     */

     public clone(): any {
        return new CNContactRXSerie();
    }

    /**
     * JSON
     */

    public fromJson(json: any, emitLoaded?: boolean): void {
        super.fromJson(json, emitLoaded);
        if (typeof json.baseurl !== 'undefined') {
            this.baseurl = json.baseurl;
        }
        if (typeof json.images !== 'undefined' && Array.isArray(json.images) && json.images.length !== 0) {
            // images
            this.images = [];
            json.images.forEach(jsonImage => {
                const image = new CNContactRXImage();
                image.fromJson(jsonImage);
                image.baseurl = this.baseurl;
                this.images.push(image);
            });
        }
        if (typeof json.rxImages !== 'undefined' && Array.isArray(json.rxImages) && json.rxImages.length !== 0) {
            // images
            this.rxImages = [];
            json.rxImages.forEach(jsonImage => {
                const image = new CNContactRXImage();
                image.fromJson(jsonImage);
                this.rxImages.push(image);
            });
        }
        this.itemchecksum = this.checksum;
    }
}
